<h4 for="label">{{variables.techsToolsManagement}}</h4>

@if (allTechnologies.length > 0) {
<mat-form-field class="tech-search-field" style="width: 15%;" appearance="outline">
  <input matInput placeholder="{{variables.search}}..." search (keyup)="onSearchChange($event)" />
</mat-form-field>
}


@if (!isAllLodaing) {
<div [formGroup]="subForm" class="d-flex">
  <div class="mt-3 type-actions-list">
    <span for="label"><strong>{{variables.selectTechnology}}</strong></span>
    @if (presTecs.length > 0) {
    <div class="list-group-control list-type-action mt-3">
      <div class="d-flex list-group-control-header">
        <div class="list-group-control-header-catalog-name">{{variables.technology}}</div>
      </div>
      @for (item of presTecs; track item; let i = $index) {
      <div class="list-group-control-item-meto" (click)="showToolsList(item.id);"
        [ngClass]="{'selected-tech':this.currentSelected === item.id}">
        <div [ngClass]="{'faded-text': !item.active}" class="list-group-control-item-name" id="{{item.name}}">
          <span class="dot"></span>
          {{ item.name }}
        </div>
        <div class="list-group-control-item-icons action_buttons">
          @if (item.editable) {
          <span (click)="$event.stopPropagation(); editTech(item.id, item.name, item.active)" class="icon-edit me-3 action_buttons-item">
            <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
          </span>
          <span (click)="$event.stopPropagation(); removeTech(item.id)" class="icon-edit me-3 action_buttons-item">
            <img src="../../../../assets/svg/BinWhite.svg" alt="Remove Icon" width="20px">
          </span>
          }
          @else {
          <span (click)="$event.stopPropagation()" class="icon-edit me-3 action_buttons-item" style=" opacity: 0.4;" [matTooltip]=cantEdit>
            <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
          </span>
          <span (click)="$event.stopPropagation()" class="icon-edit me-3 action_buttons-item" style=" opacity: 0.4;" [matTooltip]=cantEdit>
            <img src="../../../../assets/svg/BinWhite.svg" alt="Remove Icon" width="20px">
          </span>
          }
        </div>
      </div>
      }
    </div>
    }
    <br>
    @if (allTechnologies.length === 0) {
    <div class="mt-3"></div>
    }
    <app-button typeBtn="primary" style="display: flex; margin-bottom: 30px;" (click)="addNewTech()"
      message="{{variables.addNewTechnology}}"></app-button>
  </div>
  @if (isLoadingtools && !errorDetected) {
  <app-loader class="centerLoader"></app-loader>
  }
  @if (isActionsListVisible && !isAllLodaing) {
  <mat-icon class="keyboard_arrow_right">keyboard_arrow_right</mat-icon>
  }
  @if (isActionsListVisible && !isLoadingtools) {
  <div @slideToggleHorizontal class="mt-3 actions-list table-wrapper">
    <span for="label"><strong>{{variables.manageTools}}</strong></span>
    @if (allTools.length > 0) {
    <div class="list-group-control list-actions mt-3">
      <div class="d-flex list-group-control-header">
        <div class="list-group-control-header-catalog-name">{{variables.toolName}}</div>
        <div class="list-group-control-header-catalog-complexity">{{variables.earnPercentual}}</div>
        <div></div>
      </div>
      @for (item of allTools; track item) {
      <div class="list-group-control-item-macro">
        <div class="list-group-control-item-name">{{ item.name }}</div>
        <div class="list-group-control-item-complexity">{{ item.productivity.toFixed(2) }}%</div>
        <div class="list-group-control-item-icons action_buttons">
          <span (click)="editTool(item)" class="icon-edit me-3 action_buttons-item">
            <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
          </span>
          <span (click)="removeTool(item.name)" class="icon-close me-1 action_buttons-item">
            <img src="../../../../assets/svg/BinWhite.svg" alt="Bin Icon" width="15px">
          </span>
        </div>
      </div>
      }
    </div>
    }
    <br>
    @if (isActionsListVisible && allTools.length === 0) {
    <div class="mt-3"></div>
    }
    <app-button typeBtn="primary" style="display: flex; " (click)="addNewTool()"
      message="{{variables.addNewTool}}"></app-button>
  </div>
  }
</div>
}

@if (isAllLodaing && !errorDetected) {
<app-loader class="centerLoader"></app-loader>
}
@if (errorDetected) {
<app-error-message class="centerLoader" [errorMsg]="errorText"></app-error-message>
}